// File: kmpod.js
// Author: King & McGaw (web@kingandmcgaw.com)
// Requirements:
//    jQuery (included by existing theme "Supply" 8.3.0)
//      - current version 2.2.3
//      - contains vulnerabilities https://snyk.io/test/npm/jquery/2.2.3
//    lodash.js (included by templates/product.kmpod.liquid)
//      - current version 4.17.21 (up to date as of 22/12/2020)
//      - https://lodash.com/docs/4.17.21
//      - no vulnerabilities https://snyk.io/test/npm/lodash/4.17.21
//
// Description:
//    This file replaces the 3rd product option selector (frame) with frame swatches/images
//
//    1. When the page is initially rendered by the server, a single <select> element is created containing all variants
//    2. option_selection.js (a Shopify library) converts it into 3 <select> inputs (type, size, frame)
//    3. Then this script replaces the 3rd <select> (frame) with clickable frame option links

var KMPod = {
  frameOptions: {
    none: {
      image: 'https://img.kingandmcgaw.com/i/frames/no_frame.jpg',
      title: 'No frame'
    },
    black: {
      image: 'https://img.kingandmcgaw.com/framecache/si-880229.jpg_type-cornercrop_maxdim-85.jpg',
      title: 'Black painted ash box'
    },
    natural: {
      image: 'https://img.kingandmcgaw.com/framecache/si-880232.jpg_type-cornercrop_maxdim-85.jpg',
      title: 'Natural oak box'
    },
    white: {
      image: 'https://img.kingandmcgaw.com/framecache/si-880231.jpg_type-cornercrop_maxdim-85.jpg',
      title: 'White painted ash box'
    },
    gold: {
      image: 'https://img.kingandmcgaw.com/framecache/si-880242.jpg_type-cornercrop_maxdim-85.jpg',
      title: 'Gold cushion'
    }
  },

  initialize: function (options) {
    this.options = {
      mediaSelector: '#productSelect-product-kmpod-template-option-0',
      sizeSelector: '#productSelect-product-kmpod-template-option-1',
      frameSelector: '#productSelect-product-kmpod-template-option-2'
    }

    // Hide "TYPE" selector since there is only one type "Art print"
    $(this.options.mediaSelector).closest('.selector-wrapper').hide()

    // Hide existing frame selector
    var wrapper = $(this.options.frameSelector).closest('.selector-wrapper')
    $(wrapper).find('select').hide()

    // Add container for frame thumbs
    $(wrapper).append("<div id='pod-frame-picker'></div>")

    KMPod.generateFrameOptions()
    this.filterFrameOptions()

    // Listen for changes to selected variant
    $(document).on('productVariantSelected', function (event, data) {
      console.log('productVariantSelected', data)
      // KMPod.filterFrameOptions()
      KMPod.selectVariant(data.variant.id)
    })
  },

  variantElement: function () {
    return document.getElementById('productSelect-product-kmpod-template')
  },

  generateFrameOptions: function () {
    var pickerHtml = _.map(window.productVariants, function (variant) {
      var podMedia = variant.option1
      var podSize = variant.option2
      var podLabel = variant.option3
      var frame = KMPod.frameOptions[podLabel]

      return `<a class="frame-thumb"
        xonclick="KMPod.selectVariant('${variant.id}');return false;"
        href="?variant=${variant.id}"
        data-variant-id="${variant.id}"
        data-pod-media="${podMedia}"
        data-pod-size="${podSize}"
        data-pod-label="${podLabel}"
        title="${podMedia} / ${podSize} / ${podLabel} frame"
        ><img src="${frame.image}" alt="${frame.title}"></a>`
    })

    // HACK: picker array is reversed to show "no frame" option last
    pickerHtml.reverse()

    $('#pod-frame-picker')
      .html(`<div class="frame-options">${pickerHtml.join('\n')}</div>`)
      .show()
  },

  filterFrameOptions: function () {
    console.log('filterFrameOptions')
    var variantId = KMPod.variantElement().value
    var selectedMedia = $(this.options.mediaSelector).val()
    var selectedSize = $(this.options.sizeSelector).val()

    // Hide all variant options
    $('[data-variant-id]').hide()

    // Then show options only for selected media & size
    $(`[data-pod-media='${selectedMedia}'][data-pod-size='${selectedSize}']`).show()

    $('[data-variant-id]').removeClass('selected')
    $(`[data-variant-id="${variantId}"]`).addClass('selected')

    this.updatePageDescription()
  },

  selectVariant: function (variantId) {
    console.log('selectVariant', variantId)
    KMPod.variantElement().value = variantId
    this.filterFrameOptions()
    this.updatePageDescription()
  },

  updatePageDescription: function () {
    var variantId = KMPod.variantElement().value
    var metaFields = window.variantMetafields[variantId]
    var productDimensions = `${metaFields['product-width'].value} x ${metaFields['product-height'].value} cm`
    var imageDimensions = `${metaFields['image-width'].value} x ${metaFields['image-height'].value} cm`
    var productDescription = metaFields['product-description']

    var productSummary = []
    productSummary.push(KMPod.toTitleCase(productDescription))
    productSummary.push(`Product size: ${productDimensions}`)
    productSummary.push(`Image size: ${imageDimensions}`)

    $('#km-product-summary').remove()
    var html = '<div id="km-product-summary" class="km-product-summary">' + productSummary.join('<br>') + '</div>'
    $('.product-description-container').append(html)
  },

  toTitleCase: function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  },

  findReplacement: function () {
    var productType = $(this.options.mediaSelector).val()
    var productSize = $(this.options.sizeSelector).val()

    return _.find(productVariants, function (variant) {
      return variant.option1 == productType && variant.option2 == productSize
    })
  }
}
